export default __webpack_public_path__ + "static/media/Whistleblowing_2_(SE).0b57cc0b.mp4";